import { faBars } from '@fortawesome/free-solid-svg-icons/faBars'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from 'gatsby'
import React from 'react'

import Logo from './Logo'

import useSiteMetadata from '../hooks/use-site-metadata'
import useCategories from '../hooks/use-categories'

const Navbar = () => {
  const { title } = useSiteMetadata()
  const categories = useCategories()

  return (
    <nav className="shadow-sm flex items-center bg-white p-3 justify-between flex-wrap">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 xl:max-w-5xl xl:px-0 flex items-center flex-no-shrink">
        <Link to={`/`} className="p-2 mr-4 inline-flex items-center">
          {/* <Logo title={title} className="fill-current text-white h-8 w-8 mr-2 hidden md:visible" /> */}
          <span className="text-xl text-green-900 font-bold uppercase tracking-wide">
            {title}
          </span>
        </Link>

        <button className="text-white inline-flex p-3 hover:bg-gray-900 rounded lg:hidden ml-auto hover:text-white outline-none nav-toggler">
          <FontAwesomeIcon icon={faBars} />
        </button>

        <div className="hidden top-navbar w-full lg:inline-flex lg:flex-grow lg:w-auto">
          <div className="lg:inline-flex lg:flex-row lg:ml-auto lg:w-auto w-full lg:items-center items-start flex flex-col lg:h-auto">
            {categories.map(({ title, slug }) => (
              <Link
                key={`navbar-${slug}`}
                to={`/${slug}/`}
                className="lg:inline-flex lg:w-auto w-full px-3 py-2 rounded text-green-800 items-center justify-center hover:bg-green-800 hover:text-white"
              >
                <span>{title}</span>
              </Link>
            ))}

            <Link
              key={`navbar-ecogesture`}
              to="/ecogestes/"
              className="lg:inline-flex lg:w-auto w-full px-3 py-2 rounded text-green-800 items-center justify-center hover:bg-green-800 hover:text-white"
            >
              <span>Éco Gestes</span>
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar
